import moment from 'moment'
import {
  List,
  Datagrid,
  TextField,
  DateField,
  EditButton,
  Filter,
  TextInput,
  ReferenceField,
  DateInput,
  SelectInput,
  usePermissions,
  useListContext,
} from 'react-admin'

import ApproveButtons from '../../components/ApproveAction/ApproveButtons'
import ApproveStatus from '../../components/ApproveAction/ApproveStatus'
import { ROLES } from '../../components/constants'
import CustomSwitchField from '../../components/CustomSwitchField'
import { exportExcel } from '../../utils/exportExcel'

const exporter = records => {
  const data = records.map(record => {
    return {
      Id: record.id,
      Name: record.name,
      Email: record.email,
      Status: record.status,
      Slug: record.slug,
      Redeemed: record.redeemed,
      BookId: record.book && record.book.id,
      Book: record.book && record.book.title,
      'Created by': record.createdUser && record.createdUser.name,
      'Created at':
        record.createdAt && moment(record.createdAt).format('DD/MM/YYYY'),
      'Updated by': record.updatedUser && record.updatedUser.name,
      'Updated at':
        record.updatedAt && moment(record.updatedAt).format('DD/MM/YYYY'),
      'Start at': record.startAt && moment(record.startAt).format('DD/MM/YYYY'),
      'Expire at':
        record.expireAt && moment(record.expireAt).format('DD/MM/YYYY'),
    }
  })

  exportExcel({
    data,
    title: `Affiliates_${moment().format('MM_DD_YYYY')}`,
    type: 'xlsx',
  })
}

const AffiliateFilter = props => {
  const { filterValues } = useListContext()
  return (
    <Filter {...props}>
      <TextInput label="Search" source="name" alwaysOn />
      <SelectInput
        label="Filter"
        source="date"
        choices={[
          { id: 'all', name: 'All' },
          { id: 'this_month', name: 'This month' },
          { id: 'last_month', name: 'Last month' },
          { id: 'custom', name: 'Choose date' },
        ]}
        alwaysOn></SelectInput>
      {'custom' === filterValues.date && (
        <DateInput label="From date" source="fromDate" alwaysOn></DateInput>
      )}
      {'custom' === filterValues.date && (
        <DateInput label="To date" source="toDate" alwaysOn></DateInput>
      )}
    </Filter>
  )
}

const AffiliateList = () => {
  const { permissions } = usePermissions()
  return (
    <List
      filters={<AffiliateFilter />}
      exporter={exporter}
      sort={{ field: 'createdAt', order: 'DESC' }}>
      <Datagrid bulkActionButtons={false} rowClick={false}>
        <TextField source="id" />
        <TextField source="name" />
        <TextField source="quantityLimit" />
        <TextField source="redeemed" />
        <DateField label="Start at" source="startAt" />
        <DateField label="Expire at" source="expireAt" />
        <ReferenceField label="Created by" source="createdBy" reference="users">
          <TextField source="name" />
        </ReferenceField>
        <ReferenceField label="Updated by" source="updatedBy" reference="users">
          <TextField source="name" />
        </ReferenceField>
        <DateField source="createdAt" />
        <DateField source="updatedAt" />
        <CustomSwitchField
          resource="affiliates"
          label="Status"
          switchField="status"
          disabled={
            ![
              ROLES.ADMIN,
              ROLES.CPSO,
              ROLES.MARKETING_MANAGER,
              ROLES.STATISTICAL_STAFF,
              ROLES.CS_MARKETING_MANAGER,
            ].includes(permissions)
          }
        />
        <ApproveStatus label="Status" statusField="approveStatus" />
        <ApproveButtons
          permissions={permissions}
          service="affiliates"
          statusField="approveStatus"
        />
        <EditButton />
      </Datagrid>
    </List>
  )
}

export default AffiliateList
